var e;!function(e){e.READ="read",e.CREATE="create",e.UPDATE="update",e.DELETE="delete"}(e||(e={}));export{e as AccessOperationEnum};